import { ISuggestion, EGender, EPartsLower } from '../../../types/fio';

export function getFilteredSuggest(suggest: ISuggestion[], gender: EGender, currentPartFIO: EPartsLower) {
  return suggest
    .filter(item => (gender !== EGender.UNKNOWN ? item.data.gender === gender : item))
    .filter(item => item.data[currentPartFIO as keyof typeof item.data]);
}
